module.exports = "/images/reciteme_button_mobile.svg?309370ff8c8e6372f503b539569e1f60";